import { useState, type FormEvent } from 'react';
import { useMutation } from '@tanstack/react-query';
import { api } from '../api';

export default function Notifications() {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [audience, setAudience] = useState<'all' | 'subscribers'>('all');
  const [result, setResult] = useState<{ ok: boolean; devices: number } | null>(null);

  const send = useMutation({
    mutationFn: () =>
      api<{ ok: boolean; devices: number }>('/api/v1/admin/notifications/broadcast', {
        method: 'POST',
        body: JSON.stringify({ title, body, audience }),
      }),
    onSuccess: (r) => {
      setResult(r);
      setTitle('');
      setBody('');
    },
  });

  const submit = (e: FormEvent) => {
    e.preventDefault();
    send.mutate();
  };

  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Broadcast notification</h1>
      <form onSubmit={submit} className="bg-surface border border-border rounded-xl p-6 max-w-2xl">
        <select
          value={audience}
          onChange={(e) => setAudience(e.target.value as 'all' | 'subscribers')}
          className="w-full mb-3 bg-bg border border-border rounded-md px-3 py-2"
        >
          <option value="all">All users</option>
          <option value="subscribers">Active subscribers only</option>
        </select>
        <input
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className="w-full mb-3 bg-bg border border-border rounded-md px-3 py-2"
        />
        <textarea
          placeholder="Body"
          value={body}
          onChange={(e) => setBody(e.target.value)}
          className="w-full mb-3 bg-bg border border-border rounded-md px-3 py-2 h-32"
        />
        <button className="bg-accent text-bg px-4 py-2 rounded-md font-semibold" disabled={send.isPending}>
          {send.isPending ? 'Sending…' : 'Send broadcast'}
        </button>
        {result ? (
          <div className="mt-4 text-success">Sent to {result.devices} devices.</div>
        ) : null}
      </form>
    </div>
  );
}
